// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"912":"d57cc4b9","9775":"d57cc4b9"}[chunkId] + ".chunk.css");